'use client';
import { jsx } from 'react/jsx-runtime';
import t$1 from 'prop-types';
import t from 'tiny-warning';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
let a = {
    noWrap: t$1.bool,
    truncate: t$1.bool
}, p = [
    'noWrap',
    'truncate'
], i = {
    h1: 'x4large',
    h2: 'x3large',
    h3: 'x2large',
    h4: 'large',
    h5: 'standard',
    h6: 'standard'
}, d = {
    h1: 'bold',
    h2: 'bold',
    h3: 'bold',
    h4: 'bold',
    h5: 'bold',
    h6: 'bold'
};
function get(e, r) {
    if (null != r && e && r in e) return e[r];
}
const Typography = renderWithRef('Typography', a, (r, n)=>{
    let { children: a, noWrap: s = false, truncate: l = false, as: c, component: f } = r, g = new Set(), u = c || f;
    return 'string' == typeof u && u in d && g.add('swan-heading'), s && g.add("swan-text-no-wrap"), l && g.add("swan-text-truncate"), 'string' == typeof u && u in d && t(r.__dangerouslySuppressWarning, `Typography rendered as ${u}: Consider using SWAN's heading component <${u.toUpperCase()}>`), jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        propKeysToRemove: p,
        classNames: g,
        props: _object_spread({
            fontSize: r.fontSize || get(i, u) || void 0,
            fontWeight: r.fontWeight || get(d, u)
        }, r),
        children: a
    });
});

export { Typography };
